var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2780_9019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6883 16.8683C31.6883 15.7807 31.6001 14.6872 31.412 13.6172H16.3203V19.7785H24.9626C24.604 21.7656 23.4517 23.5235 21.7644 24.6405V28.6383H26.9204C29.9481 25.8516 31.6883 21.7362 31.6883 16.8683Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3195 32.5005C20.6348 32.5005 24.2739 31.0836 26.9254 28.6379L21.7694 24.6401C20.3349 25.616 18.483 26.1687 16.3254 26.1687C12.1512 26.1687 8.61197 23.3526 7.34208 19.5664H2.02148V23.6877C4.73763 29.0906 10.2699 32.5005 16.3195 32.5005Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33703 19.5676C6.66681 17.5805 6.66681 15.4287 7.33703 13.4416V9.32031H2.02231C-0.247022 13.8413 -0.247022 19.1678 2.02231 23.6889L7.33703 19.5676Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3195 6.83288C18.6006 6.79761 20.8052 7.65596 22.4573 9.23156L27.0253 4.66349C24.1328 1.94734 20.2938 0.454045 16.3195 0.501078C10.2699 0.501078 4.73763 3.91096 2.02148 9.31975L7.3362 13.441C8.60021 9.64898 12.1453 6.83288 16.3195 6.83288Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2780_9019"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailLogo);
export default __webpack_public_path__ + "static/media/gmail-logo.aa5c19975808f5180fb06e0a9e10b45e.svg";
export { ForwardRef as ReactComponent };